const mouseCodes = {
    1: 'M1',
    2: 'M2',
    4: 'M3',
    8: 'M4',
    16: 'M5'
}

export default {mouseCodes}